@custom-media --tablet-until (max-width: 768px);
@custom-media --tablet-from (min-width: 769px);

:host {
  display: block;
  margin: var(--jb-select-margin, 0 0);
  width: var(--jb-select-width, 100%);
}

:host(:focus),
:host(:focus-visible) {
  outline: none;
}

:host(:state(open)) {
  .select-box {
    @media(--tablet-from) {
      /*when there is focus on whole select means menu is open so we change select styles*/
      border-color: var(--border-color);
      border-bottom-color: transparent;
      border-radius: var(--rounded) var(--rounded) 0 0;
    }
  }
}

:host(:state(disabled)) {
  .jb-select-web-component .select-box .end-section .clear-button {
    display: none;
  }
}

.jb-select-web-component {
  width: 100%;
  box-sizing: border-box;
  container-type: inline-size;

  &.--has-value {

    /*if user select a option and value is set and not null*/
    .select-box {
      border-color: var(--jb-select-border-color-selected, var(--border-color));
      background-color: var(--jb-select-bgcolor-selected, var(--select-box-bg-color));
    }

    .select-box .end-section .clear-button {
      display: block;
    }
  }

  label {
    width: 100%;
    margin: var(--label-margin);
    display: block;
    font-size: var(--label-font-size);
    color: var(--label-color);
    font-weight: var(--jb-input-label-font-weight, 300);

    &:empty {
      display: none;
    }
  }



  .select-box {
    width: 100%;
    box-sizing: border-box;
    height: var(--height);
    border: solid var(--border-width) var(--border-color);
    border-bottom: solid var(--border-bottom-width) var(--border-color);
    border-radius: var(--box-border-radius);
    background-color: var(--select-box-bg-color);
    margin: var(--jb-select-box-margin, 0px);
    overflow: hidden;
    display: grid;
    grid-template-rows: minmax(0, 1fr);
    grid-template-columns: auto 1fr auto;
    padding-inline-end: var(--jb-select-box-padding-end, 1rem);
    align-items: center;

    .start-section {
      height: 100%;
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .middle-section {
      position: relative;
      width: 100%;
      height: 100%;
      flex: 1;

      .selected-value-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        overflow: hidden;
        z-index: var(--base-z-index);

        &.--search-typed {
          opacity: 0;
        }

        .selected-value {
          width: 100%;
          box-sizing: border-box;
          height: 100%;
          background-color: transparent;
          padding: var(--selected-value-padding);
          display: block;
          font-family: inherit;
          font-size: var(--selected-value-font-size);
          color: var(--value-color);
          margin: 0;
          border-radius: 0;
          display: flex;
          align-items: center;
          overflow: hidden;
          white-space: nowrap;

          .multiple-divider {
            padding-inline-end: 0.25rem;
          }
        }
      }

      .front-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        overflow: hidden;
        z-index: calc(var(--base-z-index) + 1);

        .search-input {
          height: 100%;
          background-color: transparent;
          padding: var(--inline-slots-padding);
          display: block;
          margin: 0;
          border-radius: 0;
          font-size: var(--input-font-size);

          &:focus {
            outline: none;
          }

          &::placeholder {
            color: var(--placeholder-color);
            font-size: var(--jb-select-placeholder-font-size, var(--input-font-size));
          }
        }
      }
    }

    .end-section {
      display: flex;
      gap: 1.5rem;
      align-items: center;
      padding-inline-start: 0.5rem;

      .arrow-icon {
        margin: var(--jb-select-arrow-icon-margin, 0 0 0 0);
      }

      .clear-button {
        /*show when there is value*/
        display: none;
        --icon-size: var(--clear-icon-size);
        height: 100%;
      }
    }

    ::slotted([slot="start-section"]),
    ::slotted([slot="end-section"]) {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      max-height: 100%;
      overflow-y: hidden;
      background-color: transparent;
      padding: var(--inline-slots-padding);
      width: auto;
      box-sizing: border-box;
    }

    &:focus-within .selected-value {
      opacity: 0.7;
      transition: all 0.3s ease;
    }


  }

  .message-box {
    font-size: var(--message-font-size);
    padding: 0.125rem var(--inline-space);
    color: var(--message-color);
    display: var(--jb-select-message-box-display, block);

    &:empty {
      padding: 0;
    }
  }

  .popover-wrapper {
    position: relative;

    .select-list-wrapper {
      @media(--tablet-from) {
        width: 100cqi;
        --jb-popover-border-radius: var(--list-border-radius);
        --jb-popover-bg-color: var(--select-box-bg-color);
        --jb-popover-top: 0;
        --jb-popover-margin-top: calc(-1 * var(--border-bottom-width));
      }

      &::part(content) {

        @media(--tablet-from) {
          /*in desktop*/
          border: solid var(--border-width) var(--border-color);
          border-bottom: solid var(--border-bottom-width) var(--border-color);
          border-top: none;
        }
      }

      .mobile-search-input-wrapper {
        display: none;

        @media(--tablet-until) {
          display: block;
          margin-block-end: 1rem;
          margin-inline: 0.75rem;

          .search-input {
            background-color: var(--jb-select-mobile-input-bgcolor, var(--select-box-bg-color));
            border-radius: var(--box-border-radius);
            padding: 0.125rem 0.75rem;
            font-size: 1rem;
            width: 100%;
            height: var(--height);
          }
        }

      }


      .select-list {
        width: 100%;
        max-height: var(--jb-select-list-max-height, 400px);
        overflow-y: auto;

        slot {
          padding: var(--jb-select-list-padding, 16px 0);

          &:empty {
            padding: 0;
          }
        }

        /* option style places */

        &::-webkit-scrollbar {
          width: 9px;
          background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: var(--list-scroll-color);
          border-radius: var(--jb-select-list-scroll-border-radius, 4px);
        }
      }

      .empty-list-placeholder {
        display: none;
        text-align: center;
        color: var(--empty-list-placeholder-color);
        font-style: italic;
        font-size: var(--input-font-size);

        &.--show {
          display: block;
        }
      }

    }
  }

  .search-input {
    border: none;
    width: 100%;
    box-sizing: border-box;
    display: block;
    font-family: inherit;
    font-size: var(--input-font-size);
    color: var(--value-color);

    &:disabled {
      cursor: inherit;
    }

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: var(--placeholder-color);
      font-size: var(--jb-select-placeholder-font-size, 1.1em);
    }
  }
}